import React, { useState, useEffect, useRef, useCallback } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Icon, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  SemanticTable,
  Texto,
  Select,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import EditarInput from "../../../components/Admin/Blog/Artigos/Editar/Input";
import { isAuthAdmin } from "../../../services/auth";

const ControleIndicacoes = (props) => {
  const [indicacoes, setIndicacoes] = useState([]);
  const emailSearch = useRef("");
  const search = useRef({
    pedido: "1,2,3",
    pagina: 1,
  });

  const optionsPedido = [
    { id: "1,2,3", value: "Tipo de indicação" },
    { id: 1, value: "CI" },
    { id: 3, value: "Diretas (email)" },
  ];

  useEffect(() => {
    loadIndicacoes();
  }, []);

  const loadIndicacoes = useCallback(() => {
    api
      .get(
        `/admin/indicacoes/clube?tipo=${search.current.pedido}&email=${emailSearch.current}&page${search.current.pagina}`
      )
      .then(async (res) => {
        const acao = JSON.stringify({
          local: "controleIndicacoes",
          texto: `listou as indicacoes`,
        });

        await api.post("system_logs", { acao });

        setIndicacoes(res.data);
      })
      .catch((err) => {
        swal("Não foi possível carregar as indicações", err, "error");
      });
  }, [search.current, emailSearch.current]);

  const verifyPessoaNome = (valor) => {
    return valor ? valor.nome : "Pessoa inexistente";
  };

  const verifyPessoaEmail = (valor) => {
    return valor ? valor.email : "Pessoa inexistente";
  };

  const proximaPagina = useCallback(() => {
    search.current["pagina"] = search.current.pagina + 1;
    loadIndicacoes();
  }, [search.current, loadIndicacoes]);

  const paginaAnterior = useCallback(() => {
    if (search.current.pagina === 1) {
      swal("não é possivel voltar pois essa é a primeira pagina", "", "error");
      return;
    }

    search.current["pagina"] = search.current.pagina - 1;
    loadIndicacoes();
  }, [search.current, loadIndicacoes]);

  return (
    <Container>
      <AdminMenu />

      <Content>
        <Title>Controle de Indicações</Title>
        <div>
          <Texto>
            Escolha um tipo de indicação ou use o filtro para encontrar as
            indicações que deseja
          </Texto>
          <Texto>
            {indicacoes.length} - indicações encontradas para esse termo.
          </Texto>
          <ContainerInputSearch className="ui fluid right input">
            <Select
              value={search.current.pedido}
              onChange={(e) => {
                search.current["pedido"] = e.target.value;
                loadIndicacoes();
              }}
            >
              {optionsPedido.map((pedido) => (
                <option value={pedido.id}>{pedido.value}</option>
              ))}
            </Select>
            <EditarInput
              default={emailSearch.current}
              type="text"
              placeholder={"Procurar por email..."}
              refText={emailSearch}
            />
            <Button onClick={loadIndicacoes}>Pesquisar</Button>
          </ContainerInputSearch>
        </div>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Data</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                Nome remetente
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                Email remetente
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                Nome destinatário
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                Email destinatário
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Tipo</SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>
          {indicacoes.length > 0 ? (
            <SemanticTable.Body>
              {indicacoes.map((indicacao, index) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{indicacao.data_sys}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {verifyPessoaNome(indicacao.pessoa, "nome")}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {verifyPessoaEmail(indicacao.pessoa, "email")}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {indicacao.nome_destino}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {indicacao.email_destino}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {indicacao.tipo == 1 ? "Por um CI" : "Por um email"}
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
            </SemanticTable.Body>
          ) : (
            <h3>Nenhuma indicação encontrado</h3>
          )}
        </SemanticTable>
        <Button floated="right" onClick={proximaPagina}>
          Poxima Pagina
        </Button>
        <Button floated="left" onClick={paginaAnterior}>
          Pagina Anterior
        </Button>
      </Content>
    </Container>
  );
};

export default withRouter(ControleIndicacoes);
